import React from 'react';
import PropTypes from 'prop-types';
import AppVersion from 'components/menus/AppVersion/AppVersion';
import Paper from 'material-ui/Paper';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import Logo from 'components/ui/general/Logo';
import theme from 'theme/theme';

class Sidebar extends React.Component {
    // The styling for customized sidebar.
    sidebarStyle = {
        display: 'flex',
        flexDirection: 'column',
        order: '-1',
        transition: 'all 250ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        width: '60px',
        backgroundColor: theme.sidebar.backgroundColor,
        boxShadow: 'none',
        borderRadius: '0',
    };

    // The styling for the toggled sidebar and the check if it's a desktop or mobile
    sidebarOpenStyle(open) {
        let result = {};

        if (open) {
            result = {
                width: '250px',
                minWidth: '250px',
            };
        }

        return result;
    }

    render() {
        const {
            children,
            open,
        } = this.props;

        return (
            <Paper style={ Object.assign({}, this.sidebarStyle, this.sidebarOpenStyle(open)) }>
                <Logo />

                {
                    React.cloneElement(children, {
                        open: open,
                    })
                }

                <div style={ { marginTop: 'auto' } }>
                    <AppVersion />
                </div>
            </Paper>
        );
    }
}

Sidebar.propTypes = {
    children: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
};

const enhance = compose(
    connect(
        (state) => {
            return {
                open: state.ui.sidebarOpen,
            };
        },
        null
    ),
);

export default enhance(Sidebar);



// WEBPACK FOOTER //
// ./src/components/layout/Layout/sidebar/Sidebar.js